/*!
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */

import Logger from "../../../clients/logger";
import LauncherClient from "../../../clients/launcherClient";
import HotkeyClient from "../../../clients/hotkeyClient";
import ConfigClient from "../../../clients/configClient";
import { BootTaskCallbackInterface } from "../types";

/**
 * Boot task that registers hotkeys based on config settings
 * @private
 */
export class RegisterHotkeysTask {
	public async start(doneCallback: BootTaskCallbackInterface) {
		Logger.system.debug("registerHotkeysTask start");

		const { data: components } = await ConfigClient.getValue({
			field: "finsemble.components",
		});

		const componentNames = Object.keys(components);
		const processComponent = (componentName) => {
			const cmp = components[componentName];
			if (cmp.component && cmp.component.spawnOnHotkey) {
				const spawnComponentOnHotkey = () => {
					LauncherClient.spawn(componentName, {
						addToWorkspace: true,
						monitor: "primary",
					});
				};
				// When the key combo is pressed, spawn the component.
				HotkeyClient.addGlobalHotkey(cmp.component.spawnOnHotkey, spawnComponentOnHotkey);
			}
		};

		componentNames.forEach(processComponent);
		doneCallback("registerHotkeysTask", "bootTasks", "completed");
	}
}
